import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { exchangeSsoCode } from "../../actions/session";

function SsoCallback({ exchangeSsoCode, history }) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get("code");
    // Keep the one-time code out of browser history and referrer headers.
    window.history.replaceState({}, document.title, window.location.pathname);

    if (!code) {
      setFailed(true);
      return;
    }

    exchangeSsoCode(
      code,
      () => history.replace("/pro"),
      () => setFailed(true)
    );
  }, [exchangeSsoCode, history]);

  if (failed) {
    return (
      <div className="signin-container">
        <p>We could not complete your single sign-on.</p>
        <button type="button" onClick={() => history.replace("/")}>Return to login</button>
      </div>
    );
  }

  return <div className="signin-container"><p>Signing you in…</p></div>;
}

export default connect(null, { exchangeSsoCode })(SsoCallback);
